import cn from "classnames";
import PropTypes from "prop-types";

const CellButton = ({ onClick, className, children }) => (
  <button
    onClick={onClick}
    className={cn(
      "text-black hover:text-custom_primary bg-transparent border-0 cursor-pointer",
      className
    )}
  >
    {children}
  </button>
);

CellButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default CellButton;
